import NewApiService from "@/utils/new.api.service";

export default {
    getCatalogs(ctx){
        ctx.commit("setLoading", true);
        return new Promise((resolve, reject) => {
          NewApiService.get("catalogs")
            .then(({ data }) => {
              ctx.commit("setLoading", false);
              ctx.commit("setCatalogs", data.catalogs);
              resolve(data);
            })
            .catch(({ response }) => {
                reject(response.data.errors);
            });
        });
    },

    createCatalog(context, model) {
      context.commit("setLoading", true);
      return new Promise((resolve, reject) => {
        NewApiService.post("catalogs", model)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response)
            context.commit("set_error", response.data.errors);
          })
          .finally(() => {
            context.commit("setLoading", false);
          })
      });
    },
    
    scheduleExport(ctx, params) {
        ctx.commit("setLoading", true);
        return new Promise(resolve => {
            NewApiService.put("catalogs/" + params.id + "/schedule-export", {})
            .then(({ data }) => {
                ctx.commit("setLoading", false);
                resolve(data);
            })
            .catch(({ response }) => {
                ctx.commit("set_error", response.data.errors);
            });
        });
    },
    
    export(ctx, params) {
        ctx.commit("setLoading", true);
        return new Promise(resolve => {
        NewApiService.get(
            "catalogs/" + params.catalogId+"/export",
            {},
            { responseType: "blob" }
        )
            .then(({ data }) => {
            ctx.commit("setLoading", false);
            resolve(data);
            })
            .catch(({ response }) => {
            ctx.commit("set_error", response.data.errors);
            });
        });
    },
    uploadPrice(ctx, params) {
        ctx.commit("setLoading", true);
        return new Promise((resolve, reject) => {
          NewApiService.post(
            "catalogs/" + params.catalogId + "/upload-prices",
            params.form
          )
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            })
            .finally(() => {
                ctx.commit("setLoading", false);
            });
        });
      },
      confirmUploadPrice(ctx, params) {
        ctx.commit("setLoading", true);
        return new Promise((resolve, reject) => {
          NewApiService.put(
            "catalogs/" + params.shopId + "/upload-prices/" + params.id
          )
            .then(({ data }) => {
              resolve(data);
            })
            .catch(({ response }) => {
              reject(response);
            })
            .finally(() => {
                ctx.commit("setLoading", false);
            });
        });
      }
}